import styled from 'styled-components';
import { palette } from 'styled-theme';
import { WithDirection, device } from '@jjj/components';
import { transition, borderRadius, boxShadow } from '../../settings/style-util';

const TopbarWrapper = styled.div`
  .isomorphicTopbar {
    display: flex;
    background-color: ${palette('grayscale', 5)};
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    ${transition()};
    padding: 0 16px !important;
    justify-content: space-between;
    /* Same z-index as antd's modals and drawers, which come later in the DOM and so paint over the bar and its
       mask covers it; the sticky sidebar sits one below. */
    z-index: 1000;

    .isoLeft {
      display: flex;
      align-items: center;
      height: 100%;

      .menuOpen.triggerBtn {
        background-color: white;

        &:before {
          content: '\f2d7';
          color: black;
        }
      }

      .triggerBtn {
        width: 40px;
        height: 100%;
        display: -webkit-inline-flex;
        display: -ms-inline-flex;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background-color: transparent;
        border: 0;
        outline: 0;
        position: relative;
        cursor: pointer;

        &:before {
          content: '\f20e';
          font-family: 'Ionicons';
          font-size: 26px;
          color: ${palette('grayscale', 0)};
          line-height: 0;
          position: absolute;
        }

        @media ${device.tablet} {
          display: none;
        }
      }

      .brand-logo-link {
        display: flex;
        align-items: center;
        height: 100%;
      }

      .brand-logo {
        display: block;
        height: 20px;
        width: auto;
      }

      .brand-logo-collapsed {
        display: none;
        height: 36px;
      }
    }

    &.collapsed .isoLeft {
      .brand-logo-full {
        display: none;
      }

      .brand-logo-collapsed {
        display: block;
      }
    }

    .isoRight {
      display: flex;
      align-items: center;
      margin-bottom: 0px;

      li {
        cursor: pointer;
        line-height: normal;
        position: relative;
        display: inline-block;
        margin-left: ${props => (props['data-rtl'] === 'rtl' ? '25px' : '0')};
        margin-right: ${props => (props['data-rtl'] === 'rtl' ? '0' : '25px')};

        @media ${device.mobileL} {
          margin-left: ${props => (props['data-rtl'] === 'rtl' ? '16px' : '0')};
          margin-right: ${props => (props['data-rtl'] === 'rtl' ? '0' : '16px')};
        }

        &:last-child {
          margin: 0;
        }

        i {
          font-size: 24px;
          color: ${palette('grayscale', 2)};
          line-height: 1;

          &.fa-clock {
            font-size: 22px;
          }
        }

        .isoIconWrapper {
          position: relative;
          line-height: normal;

          span {
            font-size: 10px;
            font-weight: 900;
            font-family: 'Helvetica';
            color: ${palette('grayscale', 5)};
            background-color: ${palette('secondary', 1)};
            width: 20px;
            height: 20px;
            display: -webkit-inline-flex;
            display: -ms-inline-flex;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            line-height: 20px;
            position: absolute;
            top: -10px;
            left: ${props => (props['data-rtl'] === 'rtl' ? 'inherit' : '5px')};
            right: ${props => (props['data-rtl'] === 'rtl' ? '5px' : 'inherit')};
            ${borderRadius('50%')};
          }
        }

        &.isoNotify {
          .isoIconWrapper {
            &.no-value {
              margin-top: 0;
            }

            .fa-bell {
              font-size: 21px;
              line-height: 24px;
            }

            span {
              top: -3px;
              left: 10px;
              width: 16px;
              height: 16px;
              background-color: ${palette('primary', 0)};
            }
          }
        }

        &.isoMsg {
          .isoIconWrapper {
            span {
              background-color: ${palette('color', 1)};
            }
          }
        }

        &.isoCart {
          .isoIconWrapper {
            span {
              background-color: ${palette('color', 2)};
            }
          }
        }

        &.isoUser {
          cursor: pointer;

          .avatar-wrapper {
            display: block;
          }

          .user-name {
            font-weight: 900;
            color: ${palette('grayscale', 5)};
          }

          .isoImgWrapper {
            width: 24px;
            height: 24px;
            display: inline-block;
            align-items: center;
            justify-content: center;
            position: relative;
            background-color: ${palette('grayscale', 9)};
            ${borderRadius('50%')};
            position: relative;

            img {
              height: 100%;
              object-fit: cover;
              border-radius: 20px;
            }

            .userActivity {
              width: 10px;
              height: 10px;
              display: block;
              background-color: ${palette('color', 3)};
              position: absolute;
              bottom: 0;
              right: 3px;
              border: 1px solid ${palette('grayscale', 5)};
              ${borderRadius('50%')};
            }
          }
        }
      }
    }
  }

  .isoUserDropdown {
    .ant-popover-inner {
      .ant-popover-inner-content {
        .isoUserDropdownContent {
          padding: 7px 0;
          display: flex;
          flex-direction: column;
          position: absolute;
          top: 0;
          right: 0;
          background-color: ${palette('grayscale', 5)};
          width: 220px;
          min-width: 160px;
          flex-shrink: 0;
          ${borderRadius('5px')};
          ${boxShadow('0 2px 10px rgba(0,0,0,0.2)')};
          ${transition()};

          .isoDropdownLink {
            font-size: 13px;
            color: ${palette('text', 1)};
            line-height: 1.1;
            padding: 7px 15px;
            background-color: transparent;
            text-decoration: none;
            display: flex;
            justify-content: flex-start;
            ${transition()};

            &:hover {
              background-color: ${palette('secondary', 6)};
            }
          }
        }
      }
    }
  }

  // Dropdown
  .ant-popover {
    .ant-popover-inner {
      .ant-popover-inner-content {
        .isoDropdownContent {
          display: flex;
          flex-direction: column;
          position: absolute;
          top: 0;
          right: 0;
          width: 310px;
          background-color: ${palette('grayscale', 5)};
          min-width: 160px;
          flex-shrink: 0;
          ${borderRadius('5px')};
          ${boxShadow('0 2px 10px rgba(0,0,0,0.2)')};
          ${transition()};

          @media ${device.tablet} {
            width: 360px;
          }

          .isoDropdownBody {
            width: 100%;
            height: 300px;
            overflow-y: auto;
            display: flex;
            flex-direction: column;
            margin-bottom: 10px;
            background-color: ${palette('grayscale', 6)};

            .isoDropdownListItem {
              padding: 15px 30px;
              flex-shrink: 0;
              text-decoration: none;
              display: flex;
              flex-direction: column;
              text-decoration: none;
              width: 100%;
              ${transition()};

              &:hover {
                background-color: ${palette('grayscale', 3)};
              }

              .isoListHead {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 5px;
              }

              h5 {
                font-size: 13px;
                font-weight: 500;
                color: ${palette('text', 0)};
                margin-top: 0;
              }

              p {
                font-size: 12px;
                font-weight: 400;
                color: ${palette('text', 2)};
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }

              .isoDate {
                font-size: 11px;
                color: ${palette('grayscale', 1)};
                flex-shrink: 0;
              }
            }
          }

          .isoViewAllBtn {
            font-size: 13px;
            font-weight: 500;
            color: ${palette('text', 2)};
            padding: 10px 15px 20px;
            display: flex;
            text-decoration: none;
            align-items: center;
            justify-content: center;
            text-align: center;
            ${transition()};

            &:hover {
              color: ${palette('primary', 0)};
            }
          }

          .isoDropdownFooterLinks {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 30px 20px;

            a {
              font-size: 13px;
              font-weight: 500;
              color: ${palette('text', 0)};
              text-decoration: none;
              padding: 10px 20px;
              line-height: 1;
              border: 1px solid ${palette('border', 1)};
              display: flex;
              align-items: center;
              justify-content: center;
              ${transition()};

              &:hover {
                background-color: ${palette('primary', 0)};
                border-color: ${palette('primary', 0)};
                color: #ffffff;
              }
            }

            h3 {
              font-size: 14px;
              font-weight: 500;
              color: ${palette('text', 0)};
              line-height: 1.3;
            }
          }

          &.withImg {
            .isoDropdownListItem {
              display: flex;
              flex-direction: row;

              .isoImgWrapper {
                width: 35px;
                height: 35px;
                overflow: hidden;
                margin-right: 15px;
                display: -webkit-inline-flex;
                display: -ms-inline-flex;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                background-color: ${palette('grayscale', 9)};
                ${borderRadius('50%')};

                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }

              .isoListContent {
                width: 100%;
                display: flex;
                flex-direction: column;

                .isoListHead {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-bottom: 10px;
                }

                h5 {
                  margin-bottom: 0;
                  padding-right: 15px;
                }

                .isoDate {
                  font-size: 11px;
                  color: ${palette('grayscale', 1)};
                  flex-shrink: 0;
                }

                p {
                  white-space: normal;
                  line-height: 1.5;
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const LogoPlaceholder = styled.a`
  align-items: center;
  color: ${palette('grayscale', 6)};
  display: flex;
  font-size: 21px;
  font-weight: 300;
  height: 100%;
  justify-content: center;
  letter-spacing: 3px;
  text-decoration: none;
  text-transform: uppercase;
`;

export default WithDirection(TopbarWrapper);
